<template>
  <Modal class="modal-dark" :onClose="onClose">
    <div slot="header" class="modal-title">Manage Live Stream</div>
    <div class="modal-body">
      <div class="form-group">
        <label class="form-title">{{$t('common:name')}}</label>
        <input
          class="form-control"
          :class="{ 'is-invalid': error.name }"
          @blur="validateRequiredField('name')"
          v-model="streamData.name"/>
        <div class="invalid-feedback">{{error.name}}</div>
      </div>
      <div class="form-group">
        <label class="form-title">{{$t('channel.creator.liveStream.title')}}</label>
        <input
          class="form-control"
          :class="{ 'is-invalid': error.manifestUrl }"
          @blur="validateRequiredField('manifestUrl')"
          v-model="streamData.manifestUrl"/>
          <div class="invalid-feedback">{{error.manifestUrl}}</div>
      </div>
      <div class="form-group">
        <label class="form-title">{{$t('channel.creator.liveStream.resolution')}}</label>
        <div class="resolution-container">
          <input class="form-control mr-2"
            placeholder="width"
            type="number"
            v-model="streamData.resolution.width"/>
          x
          <input
            class="form-control ml-2"
            placeholder="height"
            type="number"
            v-model="streamData.resolution.height"/>
        </div>
      </div>
      <div class="form-group checkbox-container">
        <input
          class="checkbox"
          type="checkbox"
          :checked="streamData.isDefaultForPreview && streamData.isDefaultForExport"
          @input="onCheckDefault" />
        <label class="form-title">{{$t('channel.creator.liveStream.default')}}</label>
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-outline delete-button"
        type="button"
        v-if="isShowDeleteButton"
        @click="onClickDelete">
        {{$t('common:delete')}}
      </button>
      <button
        class="btn btn-primary"
        type="button"
        :disabled="!canClickSave"
        @click="onClickSave">
        {{$t('common:save')}}
      </button>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash';
import Modal from '@/components/elements/Modal.vue';

export default {
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    stream: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      streamData: {
        name: '',
        manifestUrl: '',
        resolution: {
          width: null,
          height: null,
        },
        isDefaultForPreview: true,
        isDefaultForExport: true,
      },
      isShowDeleteButton: false,
      error: {},
    };
  },
  components: {
    Modal,
  },
  created() {
    if (this.stream) {
      this.isShowDeleteButton = true;
    }
    this.streamData = _.defaults(this.stream, this.streamData);
  },
  computed: {
    canClickSave() {
      return this.streamData.name && this.streamData.manifestUrl;
    },
  },
  methods: {
    onClickSave() {
      this.$emit('update:stream', this.streamData);
      this.onClose();
    },
    onClickDelete() {
      this.$emit('update:stream', null);
      this.onClose();
    },
    onCheckDefault(event) {
      const isChecked = event.target.checked;
      this.isDefaultForPreview = isChecked;
      this.isDefaultForExport = isChecked;
    },
    validateRequiredField(fieldName) {
      if (!this.streamData[fieldName]) {
        this.$set(this.error, fieldName, this.$t('validation:fillInformation'));
      } else {
        this.$set(this.error, fieldName, '');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.form-control {
  border: 1px solid $dark-500;
  background: $dark-secondary;
  color: #FFF;
}

.form-title {
  font-size: $font-size-base;
}

.resolution-container {
  display: flex;
  align-items: center;
}

.delete-button {
  color: $gray-600;
  margin-right: auto;
}
.delete-button:hover {
  text-decoration: underline;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin-top: $spacer * 1.25;
  .form-title {
    margin-bottom: 0;
  }
  .checkbox {
    margin-right: $spacer;
  }
}

</style>
